'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sjs_js_Map$() {
}
export { $c_sjs_js_Map$ as $c_sjs_js_Map$ };
$p = $c_sjs_js_Map$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sjs_js_Map$;
/** @constructor */
function $h_sjs_js_Map$() {
}
export { $h_sjs_js_Map$ as $h_sjs_js_Map$ };
$h_sjs_js_Map$.prototype = $p;
$p.Sr = (function(properties) {
  var map = new Map();
  properties.a6(new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((pair$2$2) => map.set(pair$2$2.ac, pair$2$2.ad))));
  return map;
});
var $d_sjs_js_Map$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sjs_js_Map$, "scala.scalajs.js.Map$", ({
  vT: 1
}));
export { $d_sjs_js_Map$ as $d_sjs_js_Map$ };
var $n_sjs_js_Map$;
function $m_sjs_js_Map$() {
  if ((!$n_sjs_js_Map$)) {
    $n_sjs_js_Map$ = new $c_sjs_js_Map$();
  }
  return $n_sjs_js_Map$;
}
export { $m_sjs_js_Map$ as $m_sjs_js_Map$ };
